import React, { useState, useEffect } from 'react';
import { useReducerRequest, Util } from '@thinkwell/react.common'
import { Spinner } from '@thinkwell/react.polaris'

export default function LogoutButton(props) {
  const [state, onLogout] = useReducerRequest('get', {onSuccess: () => {
    if(props.params) {
      let url = window.location.href
      Object.keys(props.params).forEach((paramName) => {
        const paramValue = props.params[paramName]
        url = Util.setParam(url, paramName, paramValue);
      })
      window.location.assign(url)
    } else {
      window.location.reload()
    }
  }, onError: () => {
    // redirect to logout page if xhr request failed
    var now = new Date();
    var expiresDate = new Date( now.getTime() + 30000 );
    document.cookie = 'logoutredirecturl=/pages/free-trial;expires=' + expiresDate.toGMTString()+';path=/';
    window.location.assign('/account/logout')
  }})

  return (<Spinner active={state.requesting}>
    <input
      id="logout-button"
      className="button"
      type="submit"
      value="Use Different Account"
      onClick={() => { onLogout('/account/logout') }}
      disabled={!!state.requesting}/>
  </Spinner>)
}
